module.exports = __webpack_public_path__ + "static/media/anthropic_logo4.73786269.png";